export const UPDATE_ARMOR_PIECES = 'UPDATE_ARMOR_PIECES';
export const UPDATE_JEWELRY_PIECES = 'UPDATE_JEWELRY_PIECES';
export const UPDATE_WEAPON_PIECES = 'UPDATE_WEAPON_PIECES';
export const SET_ESO_NAME = 'SET_ESO_NAME';
export const UPDATE_GEAR_LEVEL = 'UPDATE_GEAR_LEVEL';
export const UPDATE_LEVEL_SLIDER = 'UPDATE_LEVEL_SLIDER';
export const UPDATE_ARMOR = 'UPDATE_ARMOR';
export const UPDATE_JEWELRY = 'UPDATE_JEWELRY';
export const UPDATE_WEAPONS = 'UPDATE_WEAPONS';
export const UPDATE_PAYMENT_TYPE = 'UPDATE_PAYMENT_TYPE';
export const TERMS_RESPONSE = 'TERMS_RESPONSE';
export const RESTART = 'RESTART';
export const TOGGLE_REVIEW = 'REVIEW';
export const SUCCESSFUL_REQUEST = 'SUCCESSFUL_REQUEST';
export const FAILED_REQUEST = 'FAILED_REQUEST';
export const RETRY = 'RETRY';
export const SET_GUILD_DATA = 'SET_GUILD_DATA';
export const SET_GUILD_MNEMONIC = 'SET_GUILD_MNEMONIC';
export const SET_GUILD_REQUEST_CODE = 'SET_GUILD_REQUEST_CODE';
export const UPDATE_ARMOR_MATS = 'UPDATE_ARMOR_MATS';
export const UPDATE_JEWELRY_MATS = 'UPDATE_JEWELRY_MATS';
export const UPDATE_WEAPON_MATS = 'UPDATE_WEAPON_MATS';
export const UPDATE_NOTES = 'UPDATE_NOTES';
